export default function formatDateArabicDZ(dateStr, format = "full") {
  const dateObj = new Date(dateStr);

  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false, // Use 24-hour format
    timeZone: "Africa/Algiers", // Algeria's time zone
  };

  switch (format) {
    case "date":
      return dateObj.toLocaleDateString("ar-DZ", {
        timeZone: "Africa/Algiers",
      });
    case "time":
      return dateObj.toLocaleTimeString("ar-DZ", {
        timeZone: "Africa/Algiers",
        hour12: false,
      });
    case "full":
      return dateObj.toLocaleString("ar-DZ", options);
    case "custom":
      return `${dateObj.toLocaleDateString("ar-DZ", {
        timeZone: "Africa/Algiers",
      })} ${dateObj.toLocaleTimeString("ar-DZ", {
        timeZone: "Africa/Algiers",
        hour12: false,
      })}`;
    default:
      return dateObj.toLocaleString("ar-DZ", options);
  }
}
